// extracted by mini-css-extract-plugin
export default {"imr":"style-module--imr--bf6ed","simple":"style-module--simple--c7cbb"};